import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "../../assets/style/admin/style.css";
import "../../assets/style/admin/all.min.css";
import { loadBusiness, setSelectedBusiness } from "../../slices/BusinessesSlice";
import Table from "../../components/admin/Table";
import { MessageAlert } from "../../components/admin/MessageAlert";

export function ManageBusiness() {
  const dispatch = useDispatch();
  const businessState = useSelector(
    (state) => {console.log("Printing State");console.log(state);return state.businesses}
  );
  const [alertType, setAlertType] = useState("")
  const auth = useSelector((state) => state.auth?.authData?.user?.user);
  const [ alertParams, setAlertParams ] = useState({
    success:false,
    message:"",
    loading:false
  })
  const businessData = businessState.userBusinessData
  console.log("Printing Business State");
  console.log(businessState);
  console.log("Printing auth");
  console.log(auth);
  useEffect(() => {
    dispatch(loadBusiness(auth.id));
    console.log("Dispatched Business Loading Data");
  }, [auth.id, dispatch]);

  useEffect( ()=>{
    if(businessState.error){
      setAlertType("error")
    }else if(businessState.success){
      setAlertType("success")
    }

    setAlertParams({
      success:businessState.success,
      message:businessState.message,
      loading:businessState.loading
    })

  },[businessState])

  let selectBusiness = (businessData) => {
    const businessDetails = {
      id: businessData.id,
      tradeName: businessData.tradeName,
      gstin: businessData.gstin,
      panNo: businessData.panNumber,
    };
    setAlertType("success")
    setAlertParams({
      success:true,
      message:`Business changed successfully (${businessData.tradeName})`,
      loading:false
    })
    localStorage.setItem("SelectedBusiness", JSON.stringify(businessDetails));
    dispatch(setSelectedBusiness())
    //window.location.reload(true)
    
  };
  const columns = [
    {
      name: "TRADE NAME",
      selector: (row) => (
        <Link
          onClick={() => {
            selectBusiness(row);
          }}
          to={"#"}
        >
          {row.tradeName}
        </Link>
      ),
      sortable: true,
      center: true,
    },
    {
      name: "CONSITUTION",
      selector: (row) => row.constitutionBusiness,
      sortable: true,
      center: true,
    },
    {
      name: "Type Of Supplier",
      selector: (row) => row.typeOfSupplier,
      sortable: true,
      center: true,
    },
    {
      name: "GSTIN",
      selector: (row) => row.gstin,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      button: false,
      selector: "action",
      center: true,
      cell: () => (
        <Link to={"#"} className="sidebar-link" data-toggle="tab">
          {" "}
          <i className="fa fa-edit"></i>{" "}
        </Link>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
    },
  ];
  return (
    <div className="revenue-wrapper">
      <div className="row">
        <div className="col-lg-12">
          <div className="card table-card">
            <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
              <h4 className="card-title mB25 mb-sm-0">Businesses</h4>
              <div className="d-flex align-items-center">
                <Link
                  to={"/users-list"}
                  className="button blue-button mt-3 mr-3"
                  data-toggle="tab"
                >
                  Manage Users
                </Link>
                <Link
                  to={"/roles-list"}
                  className="button blue-button mt-3 mr-3"
                  data-toggle="tab"
                >
                  Roles
                </Link>
                <Link
                  to={"/add-business/BusinessInformation"}
                  className="button blue-button mt-3"
                  data-toggle="tab"
                >
                  Add Business
                </Link>
              </div>
            </div>
            
            <Table
              totalCount={businessData.count}
              data={businessData.rows}
              columns={columns}
            />
          </div>
        </div>
      </div>
      { (alertType!== "")?<MessageAlert 
        type={alertParams.success?"success":"error"}
        message={alertParams.message}
        isLoading={alertParams.loading}
      />:""}
    </div>
  );
}
